export const cupertinoPaneScrollSafeSettings = {
	fastSwipeClose: false,
	topperOverflow: false,
	dragBy: ['.draggable'],
};

export function buildCupertinoPaneSettings(overrides = {}) {
	return {
		backdrop: true,
		backdropOpacity: .7,
		cssClass: 'mobile-pane',
		animationType: 'ease-out',
		bottomOffset: 0,
		...cupertinoPaneScrollSafeSettings,
		...overrides,
	};
}
